import {
  ArrowLeftOutlined,
  LoadingOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { Button, Flex, Form, Row, Space, Spin, Typography } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import SignApi from "../../../../apis/SignApi";
import SupportApi from "../../../../apis/SupportApi";
import {
  disableViewTutorial,
  getParamFromUrl,
  getTutorialCode,
  isNullOrEmpty,
  showNotification,
} from "../../../../common";
import FiledNameFileChangeInfo from "../../../../common/FiledNameFileChangeInfo";
import TypeFromLockCer from "../../../../common/TypeFromLockCer";
import ModalPromotion from "../../../ModalPromotion";
import ConfirmChangeInfo from "./ConfirmChangeInfo";
import ContactInfo from "./ContactInfo";
import Header from "./Header";
import InfoOrg from "./InfoOrg";
import InfoPerson from "./InfoPerson";
import InfoPersonOrg from "./InfoPersonOrg";
import "./index.css";
import { Helmet } from "react-helmet";
import Titles from "../../../../common/Titles";
import ChangeInfoSuccess from "components/tms/support/changeinfo/component/ChangeInfoSuccess";

import { useLocation, useHistory } from "react-router-dom";
import ChangeInfoSuccessCompensation from "components/tms/support/changeinfo/component/ChangeInfoSuccessCompensation";
import ServiceApi from "apis/ServiceApi";
import GloabalConst from "common/GloabalConst";
import TutorialCode from "common/TutorialCode";
const ChangeInfo = () => {
  const location = useLocation();
  const history = useHistory();
  const paramCompensation2025 = new URLSearchParams(location.search).get(
    "isCompensation2025"
  );

  const isCompensation2025 = paramCompensation2025 === "1" || paramCompensation2025 === "3";

  const [disabledForm, setDisabledForm] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingDetailCompen, setLoadingDetailCompen] = useState(false);
  const [loadingFile, setLoadingFile] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [isOpenModalProm, setIsOpenModalProm] = useState(false);
  const [linkPromotion, setLinkPromotion] = useState("");
  const [isViewPdfSign, setIsViewPdfSign] = useState(false);
  const [isFinish, setIsFinish] = useState(false);
  const [fileAdditionals, setFileAdditionals] = useState({
    [FiledNameFileChangeInfo.TC_GTPL.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFileChangeInfo.TC_CMND_NDD.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFileChangeInfo.CN_TC_CMND.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFileChangeInfo.CN_TC_XACNHANTOCHUC.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
    [FiledNameFileChangeInfo.CN_CMND.filed]: {
      fileName: "",
      type: "",
      data: "",
    },
  });
  const [data, setData] = useState([]);
  const [tokenProgramResponse, setTokenProgramResponse] = useState({});
  const [resultSave, setResultSave] = useState({});
  const [base64FileChange, setBase64FileChange] = useState(null);

  const [form] = Form.useForm();
  const [dataPayment, setDataPayment] = useState();

  const fetchDataPayment = async () => {
    setLoadingPayment(true);
    try {
      const res = await ServiceApi.getInformationOrder({
        object: 4,
        type: data.type,
        requestId: dataCheckReq.id,
      });
      if (res && res.status === 200 && res.data.data) {
        setDataPayment(res.data.data);
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoadingPayment(false);
    }
  };
  useEffect(() => {
    if ((isFinish || data?.status === 3) && isCompensation2025 && data) {
      fetchDataPayment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinish, data, isCompensation2025]);
  const [dataCheckReq, setDataCheckReq] = useState({});

  const fetchDataDetailCapBu = async () => {
    setLoadingDetail(true);
    try {
      const resCheck = await ServiceApi.checkrequestcapbu();
      if (resCheck.data.status === 200) {
        if (resCheck.data.data) {
          if (resCheck.data.data.id) {
            setDisabledForm(false);
          }
          return resCheck.data.data;
        }
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoadingDetail(false);
    }
  };

  const getCertInfoCapBu = async () => {
    setLoadingDetail(true);
    try {
      const resCheck = await ServiceApi.getCertInfoCapBu();
      if (resCheck.data.status === 200) {
        if (resCheck?.data?.data?.data) {
          return resCheck.data.data.data;
        }
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoadingDetail(false);
    }
  };

  useEffect(() => {
    getTutorialCode();
    if (isCompensation2025) {
      localStorage.setItem(
        GloabalConst.TUTORIAL_CODE,
        TutorialCode.RENEWCERT_COMPENSATION_CHANGE_INFO.value
      );
      Promise.all([fetchDataDetailCompensation(), fetchDataDetailCapBu(), getCertInfoCapBu()])
        .then(([resCompensation, dataDetailCapBu, dataCertCapBu]) => {
          if (dataDetailCapBu) {
            setDataCheckReq(dataDetailCapBu);
            if (resCompensation.status === 1) {
              generateFileChangeInfo(
                dataDetailCapBu.id,
                resCompensation.representFullName
              );
              setResultSave({
                id:dataDetailCapBu.id,
                serial: dataCertCapBu.serinumberCert
              })
            }
          }
        })
        .catch((error) => {
          console.error("Error in one of the promises:", error);
          showNotification("error", error.message, "Thông báo");
        });
    } else {
      fetchDataDetail();
    }
    const popupParam = getParamFromUrl("openPopup");
    if (!isNullOrEmpty(popupParam)) {
      setIsOpenModalProm(true);
      setLinkPromotion(popupParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCompensation2025]);

  useEffect(() => {
    if (isFinish) {
      disableViewTutorial();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinish]);

  const [errData, setErrData] = useState();

  const setFormError = (
    dataForm,
    key,
    message = "Vui lòng tải lên file đính kèm!"
  ) => {
    if (!dataForm) {
      setErrData((pre) => ({
        ...pre,
        [key]: message,
      }));
    } else {
      setErrData((pre) => ({
        ...pre,
        [key]: "",
      }));
    }
  };

  const onFinish = async (values) => {
    let request;
    setLoading(true);
    try {
      if (data.type === TypeFromLockCer.TO_CHUC) {
        request = {
          ...values,
          filePassport:
            fileAdditionals[FiledNameFileChangeInfo.TC_CMND_NDD.filed].data,
          fileLegal:
            fileAdditionals[FiledNameFileChangeInfo.TC_GTPL.filed].data,
        };

        setFormError(
          fileAdditionals[FiledNameFileChangeInfo.TC_CMND_NDD.filed].data,
          FiledNameFileChangeInfo.TC_CMND_NDD.filed
        );
        setFormError(
          fileAdditionals[FiledNameFileChangeInfo.TC_GTPL.filed].data,
          FiledNameFileChangeInfo.TC_GTPL.filed
        );

        if (!request.filePassport || !request.fileLegal) {
          setLoading(false);
          return;
        }

        if (isCompensation2025) {
          request.isCompensation2025 = Number(paramCompensation2025);
        }

        handleRequest(SupportApi.organization, 201, request);
      } else if (data.type === TypeFromLockCer.CA_NHAN_THUOC_TO_CHUC) {
        request = {
          ...values,
          filePassport:
            fileAdditionals[FiledNameFileChangeInfo.CN_TC_CMND.filed].data,
          fileCompany:
            fileAdditionals[FiledNameFileChangeInfo.CN_TC_XACNHANTOCHUC.filed]
              .data,
        };
        if (isCompensation2025) {
          request.isCompensation2025 = Number(paramCompensation2025);
        }
        setFormError(
          fileAdditionals[FiledNameFileChangeInfo.CN_TC_CMND.filed].data,
          FiledNameFileChangeInfo.CN_TC_CMND.filed
        );
        setFormError(
          fileAdditionals[FiledNameFileChangeInfo.CN_TC_XACNHANTOCHUC.filed]
            .data,
          FiledNameFileChangeInfo.CN_TC_XACNHANTOCHUC.filed
        );

        if (!request.filePassport || !request.fileCompany) {
          setLoading(false);
          return;
        }
        handleRequest(SupportApi.personBelongOrganization, 201, request);
      } else if (data.type === TypeFromLockCer.CA_NHAN) {
        request = {
          ...values,
          filePassport:
            fileAdditionals[FiledNameFileChangeInfo.CN_CMND.filed].data,
        };
        if (isCompensation2025) {
          request.isCompensation2025 = Number(paramCompensation2025);
        }
        setFormError(
          fileAdditionals[FiledNameFileChangeInfo.CN_CMND.filed].data,
          FiledNameFileChangeInfo.CN_CMND.filed
        );

        if (!request.filePassport) {
          setLoading(false);
          return;
        }
        handleRequest(SupportApi.person, 201, request);
      }
    } catch (error) {
      setLoading(false);
      console.error("error", error);
    }
  };

  const handleRequest = async (apiFunction, status, ...args) => {
    try {
      const res = await apiFunction(...args);
      if (res && res.status === status && res.data.data) {
        setResultSave(res.data.data);
        if (res.data.data.id) {
          generateFileChangeInfo(
            res.data.data.id,
            res.data.data.representFullName
          );
          setDataCheckReq({
            id: res.data.data.id,
          });
        }
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const generateFileChangeInfo = async (id, representFullName = null) => {
    setLoadingFile(true);
    try {
      let params = {};
      if (representFullName) {
        params = {
          // representFullName: representFullName
        };
      }
      const res = await SupportApi.generateFileChangeInfo(id, params);
      if (res && res.status === 200 && res.data.data) {
        setBase64FileChange(res.data.data);
        setIsViewPdfSign(true);
      } else {
        showNotification("error", "Lấy thông tin file thất bại", "Thông báo");
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoadingFile(false);
    }
  };

  const onEnabledForm = () => {
    setDisabledForm(false);
  };

  const fetchDataDetail = async () => {
    setLoading(true);
    try {
      const res = await SupportApi.detail();
      if (res && res.status === 200 && res.data.data && res.data.data.data) {
        setData(res.data.data.data);
        form.setFieldsValue({
          fullName: res.data.data.data.name,
          contactName: res.data.data.data.name,
          contactEmail: res.data.data.data.email,
          contactMobile: res.data.data.data.phone,
          email: res.data.data.data.email,
          code: res.data.data.data.code,
          identityType: res.data.data.data.identityType,
          representFullName: res.data.data.data.representFullName,
          provinceCode: res.data.data.data.provinceCode,
          districtCode: res.data.data.data.districtCode,
          address: res.data.data.data.address,
          orCompany: res.data.data.data.orCompany,
          orDepartment: res.data.data.data.orDepartment,
          orPosition: res.data.data.data.orPosition,
        });
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const fetchDataDetailCompensation = async () => {
    try {
      setLoadingDetailCompen(true);
      const res = await SupportApi.detailCompensation();
      if (
        res &&
        res.status === 200 &&
        res.data.status === 200 &&
        res.data.data
      ) {
        const dataApi = res.data.data;
        setData(dataApi);
        form.setFieldsValue({
          fullName: dataApi?.fullName,
          contactName: dataApi?.contactName || dataApi?.fullName,
          contactEmail: dataApi?.contactEmail || dataApi?.email,
          contactMobile: dataApi?.contactMobile || dataApi?.phone,
          email: dataApi?.email,
          code: dataApi?.code,
          identityType: dataApi?.identityType,
          representFullName: dataApi?.representFullName,
          provinceCode: dataApi?.provinceCode,
          districtCode: dataApi?.districtCode,
          address: dataApi?.address,
          orCompany: dataApi?.orCompany,
          orDepartment: dataApi?.orDepartment,
          orPosition: dataApi?.orPosition,
        });
        switch (dataApi.type) {
          case TypeFromLockCer.TO_CHUC:
            setFileAdditionals({
              [FiledNameFileChangeInfo.TC_CMND_NDD.filed]: {
                data: dataApi.filePresentPassport?.content,
              },
              [FiledNameFileChangeInfo.TC_GTPL.filed]: {
                data: dataApi.fileLegal?.content,
              },
            });
            break;
          case TypeFromLockCer.CA_NHAN_THUOC_TO_CHUC:
            setFileAdditionals({
              [FiledNameFileChangeInfo.CN_TC_CMND.filed]: {
                data: dataApi.filePassport?.content,
              },
              [FiledNameFileChangeInfo.CN_TC_XACNHANTOCHUC.filed]: {
                data: dataApi.fileCompany?.content,
              },
            });
            break;
          case TypeFromLockCer.CA_NHAN:
            setFileAdditionals({
              [FiledNameFileChangeInfo.CN_CMND.filed]: {
                data: dataApi.filePassport?.content,
              },
            });
            break;

          default:
            break;
        }
        return res.data.data;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoadingDetailCompen(false);
    }
  };

  const checkSetupPlugin = async () => {
    setLoading(true);
    try {
      const resCheckVersion = await SignApi.checkVersion();
      if (
        resCheckVersion &&
        resCheckVersion.status === 200 &&
        resCheckVersion.data
      ) {
        return true;
      } else {
        showNotification(
          "error",
          "Vui lòng cài đặt hoặc bật phần mềm ký",
          "Thông báo"
        );
        return false;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
      return false;
    } finally {
      setLoading(false);
    }
  };

  const signPDF = async () => {
    setLoading(true);
    try {
      if (await checkSetupPlugin()) {
        const currentDate = moment();
        const formattedDate = currentDate.format("DD-MM-YYYY HH:mm:ss");
        let infoSign = {
          fileData: base64FileChange,
          certSerial: resultSave.serial,
          signDate: formattedDate,
          fieldName: "SignatureB [002]",
          typeSign: "1",
          page: "",
          px: "",
          py: "",
          pw: "",
          ph: "",
        };
        const res = await SignApi.signPDF(infoSign);
        if (res && res.status === 200 && res.data.FileDataSigned) {
          uploadSignedFile(resultSave.id, res.data.FileDataSigned);
        } else {
          showNotification("error", res.data.ErrorDetail, "Thông báo");
        }
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const uploadSignedFile = async (id, data) => {
    setLoading(true);
    try {
      const request = { data: data };
      const res = await SupportApi.uploadSignedFile(id, request);
      if (res && res.status === 200) {
        setIsFinish(true);
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const onGoBackCheckInfo = () => {
    history.goBack();
  };

  return (
    <Spin
      spinning={
        loading || loadingPayment || loadingDetail || loadingDetailCompen || loadingFile
      }
      tip="Vui lòng đợi..."
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      <Helmet>
        <title>{Titles.SUPPORT_CHANGE_INFO.value}</title>
      </Helmet>
      <div className="container">
        {data && (
          <Flex
            justify="center"
            align="middle"
            vertical={true}
            //   style={{ minHeight: "100vh" }}
            className="change-info-container"
            style={{
              minHeight: "var(--min-height-body)",
            }}
          >
            <Header
              data={data}
              tokenProgramResponse={tokenProgramResponse}
              isFinish={isFinish}
            ></Header>
            {isFinish || data?.status === 3 ? (
              <>
                {isCompensation2025 ? (
                  <ChangeInfoSuccessCompensation
                    dataPayment={dataPayment}
                    dataDetail={data}
                    dataDetailCompensation={dataCheckReq}
                  />
                ) : (
                  <ChangeInfoSuccess />
                )}
              </>
            ) : (
              <Form
                onFinish={onFinish}
                layout="vertical"
                className="change-info-form"
                form={form}
              >
                {!isViewPdfSign ? (
                  <>
                    {data && data.type === TypeFromLockCer.TO_CHUC && (
                      <InfoOrg
                        data={data}
                        setData={setData}
                        setLoading={setLoading}
                        form={form}
                        tokenProgramResponse={tokenProgramResponse}
                        setTokenProgramResponse={setTokenProgramResponse}
                        setFileAdditionals={setFileAdditionals}
                        fileAdditionals={fileAdditionals}
                        onEnabledForm={onEnabledForm}
                      />
                    )}
                    {data &&
                      data.type === TypeFromLockCer.CA_NHAN_THUOC_TO_CHUC && (
                        <InfoPersonOrg
                          data={data}
                          setData={setData}
                          setLoading={setLoading}
                          form={form}
                          tokenProgramResponse={tokenProgramResponse}
                          setTokenProgramResponse={setTokenProgramResponse}
                          setFileAdditionals={setFileAdditionals}
                          fileAdditionals={fileAdditionals}
                          onEnabledForm={onEnabledForm}
                        />
                      )}
                    {data && data.type === TypeFromLockCer.CA_NHAN && (
                      <InfoPerson
                        data={data}
                        setData={setData}
                        setLoading={setLoading}
                        form={form}
                        tokenProgramResponse={tokenProgramResponse}
                        setTokenProgramResponse={setTokenProgramResponse}
                        setFileAdditionals={setFileAdditionals}
                        fileAdditionals={fileAdditionals}
                        onEnabledForm={onEnabledForm}
                      />
                    )}
                    <ContactInfo
                      data={data}
                      setLoading={setLoading}
                      form={form}
                      tokenProgramResponse={tokenProgramResponse}
                      setTokenProgramResponse={setTokenProgramResponse}
                      setFileAdditionals={setFileAdditionals}
                      fileAdditionals={fileAdditionals}
                      errData={errData}
                    />

                    <Row justify="center">
                      <Form.Item>
                        {isCompensation2025 && (
                          <Button
                            icon={<ArrowLeftOutlined />}
                            onClick={onGoBackCheckInfo}
                            className="btn-back"
                          >
                            Quay lại
                          </Button>
                        )}
                        <Button
                          icon={<SendOutlined />}
                          type="primary"
                          htmlType="submit"
                          disabled={disabledForm}
                        >
                          Ký file và gửi yêu cầu
                        </Button>
                      </Form.Item>
                    </Row>
                  </>
                ) : (
                  <>
                    <ConfirmChangeInfo
                      base64FileChange={base64FileChange}
                    ></ConfirmChangeInfo>
                    <Row justify="center">
                      <Form.Item>
                        <Button
                          icon={<ArrowLeftOutlined />}
                          onClick={() => setIsViewPdfSign(false)}
                          className="btn-back"
                        >
                          Quay lại
                        </Button>
                        <Button
                          icon={<SendOutlined />}
                          type="primary"
                          onClick={signPDF}
                        >
                          Ký xác nhận
                        </Button>
                      </Form.Item>
                    </Row>
                  </>
                )}
              </Form>
            )}
          </Flex>
        )}
      </div>

      {isOpenModalProm ? (
        <ModalPromotion
          setModalOpen={setIsOpenModalProm}
          isModalOpen={isOpenModalProm}
          link={linkPromotion}
        ></ModalPromotion>
      ) : (
        ""
      )}
    </Spin>
  );
};

export default ChangeInfo;
